import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ClientMergeComponent } from './client-merge.component';
import { SalonMonsterLoadMaskModule } from '../smr-load-mask/smr-load-mask.module';
@NgModule({
    declarations: [
        ClientMergeComponent,
    ],
    imports: [
        IonicModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SalonMonsterLoadMaskModule
    ],
    exports: [
        ClientMergeComponent
    ],
    providers: []
})
export class ClientMergeModule {}
